import React,{useState,useEffect} from 'react'
import {AiOutlineLogout} from 'react-icons/ai'
import { useParams,useNavigate } from 'react-router-dom'
import { googleLogout } from '@react-oauth/google'
import { userCreatedPinsQuery,userQuery,userSavedPinsQuery } from '../utils/data'
import {client } from '../client'
import MasonryLayout from './MasonryLayout'
import Spinner from './Spinner'
import { fetchUser } from '../utils/fetchUser'
const randomImageUrl = 'https://source.unsplash.com/random/?technology,nature,games/1600x900'
const activeBtnStyles = 'bg-red-500 text-white font-bold p-2 rounded-full w-20 outline-none'
const notActiveBtnStyles = 'bg-primary mr-4 text-black font-bold p-2 rounded-full width-20 outline-none'
const UserProfile = () => {
  const [user, setuser] = useState(null)
  const [pins, setPins] = useState(null)
  const [text, setText] = useState('Created')
  const [activeBtn, setactiveBtn] = useState('created')
  const navigate = useNavigate()
  const {userId}  = useParams()
   const userInfo = fetchUser()
  useEffect(() => {
   
    const query = userQuery(userId)
    client.fetch(query)
    .then((data)=>{
      setuser(data[0])
    })


  }, [userId])
  
  useEffect(() => {
    if (text==="Created") {
      const q = userCreatedPinsQuery(userId)
      client.fetch(q)
      .then((data)=>{
        setPins(data)
        
      })
    }
    else if (text==="Saved") {
      const q = userSavedPinsQuery(userId)
      client.fetch(q)
      .then((data)=>{
        setPins(data)

      })
    }
  }, [text,userId])
  

  if (!user) {
    return <Spinner message={'Loading Profile'} />
  }
  const handleLogout=()=>{
    googleLogout()
    localStorage.clear()
    navigate('/login')
  }

  return (
    <div className='relative pb-2 h-full justify-center items-center'>
      <div className='flex flex-col pb-5'>
        <div className='relative flex flex-col mb-7 '>
            <div className='flex flex-col justify-center items-center'>
              <img src={randomImageUrl} alt="bannerPic" 
              className='w-full h-370 xl:h-510 shadow-lg object-cover'
              />
              <img src={user.image} alt="" className='w-20 h-20 rounded-full -mt-10 shadow-xl object-cover ' />
              <h1 className='font-bold text-3xl text-center mt-3'>
                {user.userName}
              </h1>
              <div className='absolute top-0 z-1 right-0 p-2'>
                {userId === userInfo.sub && (
                  <button type='button'
                 onClick={handleLogout}
                  className=" bg-white font-bold p-2 text-black rounded-full cursor-pointer outline-none"
                  >
                    <AiOutlineLogout color='red' fontSize={21} />
                  </button>
                )}
              </div>
            </div>
            <div className='text-center mb-7'>
                <button type='button' onClick={
                  (e)=>{
                    setText(e.target.textContent) 
                    setactiveBtn('created')
                    }}
                  className={`${activeBtn === "created" ? activeBtnStyles:notActiveBtnStyles}`}
                    >
                      Created
                </button>
            { userInfo.sub === userId &&   <button type='button' onClick={
                  (e)=>{
                    setText(e.target.textContent)
                    setactiveBtn('saved')
                    }}
                  className={`${activeBtn === "saved" ? activeBtnStyles:notActiveBtnStyles}`}
                    >
                      Saved
                </button>}
            </div>

            {pins?.length ? <div className='px-2'>
              <MasonryLayout pins={pins}/>
            </div> : <div className='flex justify-center font-bold items-center w-full text-xl mt-2' >No Pins Found</div>}
        </div>
      </div>
    </div>
  )
}

export default UserProfile